import React, { useEffect } from "react";
import CareerCounsellingData from'../components/CareerCounsellingData'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


function Careercounselling() {
  const location = useLocation();

  // Scroll to the section if specified in the URL state
  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        // Use smooth scrolling to the section
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);


  const tabs = [
    { title: 'Vibrant and Informative University Fair', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 id='SanskarCounselling' className='title'>Sanskar School organized a vibrant and informative University Fair</h1>
    </div>
    <div className='uni-logo'>
      <marquee behavior='scroll' direction='left'>
        <div className='uni-logo-list'>
          <div className="uni-log-box">
            <img src="../newimg/logo/american-university.webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/manipal-university.webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (29).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (30).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (31).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (32).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (33).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (34).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (36).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (39).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (40).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (41).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (42).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (43).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (45).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (46).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (47).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/New Project (48).webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/northumbria-university.webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/plaksha-univesity.webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/s.p.jain.webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/shiv-nadar-university.webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/srm-institute.webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/tokyo-international-university.webp" alt="" />
          </div>
          <div className="uni-log-box">
            <img src="../newimg/logo/university-of-wisconsin-stout.webp" alt="" />
          </div>

        </div>
         </marquee>
    </div>

    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/UF2023-1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/UF2023-2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/UF2023-3.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/UF2023-4.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/UF2023-5.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/UF2023-6.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/UF2023-8.webp'></img>
        </Link>
      </div>

    </div>
  
    </div> },
  
  { title: 'University fair', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Sanskar School University Fair</h1>
    </div>

    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-01.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-03.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-04.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-05.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-06.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-07.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-08.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-09.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-10.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-11.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-13.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-15.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-18.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/University Fair/img-19.webp'></img>
        </Link>
      </div>

    </div>
    </div> },
  
  { title: 'Career Counselling – Mr. Bhuvesh Sharma', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Career Counselling – Mr. Bhuvesh Sharma</h1>
    </div>

    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Career Councelling-11.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Career Councelling-22.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Career Councelling-33.webp'></img>
        </Link>
      </div>
     
   
    
    </div>

  
    </div> },
     { title: 'Career Counseling Session', content: () => <div>
    
     <div className='cam-lower-sec'>
     <h1 className='title'>Career Counseling Session</h1>
     </div>
 
 
     
     <div className='career-counselling-row'>
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-1.webp'></img>
         </Link>
       </div>
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-2.webp'></img>
         </Link>
       </div>
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-3.webp'></img>
         </Link>
       </div>
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-4.webp'></img>
         </Link>
       </div>
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-5.webp'></img>
         </Link>
       </div>
  
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-7.webp'></img>
         </Link>
       </div>
 
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-9.webp'></img>
         </Link>
       </div>
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-10.webp'></img>
         </Link>
       </div>
       <div className='image-box'>
         <Link to="">
          <img src='../img/Career Counseling Session-11.webp'></img>
         </Link>
       </div>
      
    
     
     </div>
 
   
     </div> },
  { title: 'ICAE visits Sanskar School', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>ICAE visits Sanskar School</h1>
    </div>


    
    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University Tour_2019.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University Tour_2019_1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University Tour_2019_2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University Tour_2019_3.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University Tour_2019_4.webp'></img>
        </Link>
      </div>
 
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University Tour_2019_5.webp'></img>
        </Link>
      </div>

      <div className='image-box'>
        <Link to="">
         <img src='../img/American University Tour_2019_6.webp'></img>
        </Link>
      </div>
    </div>

  
    </div> },
  { title: 'American University Tour', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>American University Tour </h1>
    </div>

    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_3.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_4.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_5.webp'></img>
        </Link>
      </div>
 
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_6.webp'></img>
        </Link>
      </div>

      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_7.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_8.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_9.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_10.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_11.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_12.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_13.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/American University_14.webp'></img>
        </Link>
      </div>
  


    </div>

  
    </div> },
  { title: 'IC3 Regional Forum', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>IC3 Regional Forum held at Sanskar School</h1>
    </div>



    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-3.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-4.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-5.webp'></img>
        </Link>
      </div>
 
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-6.webp'></img>
        </Link>
      </div>

      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-7.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-8.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-9.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-10.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-11.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-12.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-13.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-14.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-15.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-16.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-17.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-18.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-19.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-21.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-22.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-23.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-24.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-25.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-26.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-27.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-28.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-29.webp'></img>
        </Link>
      </div>
  
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-30.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-31.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-32.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-33.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ic3/IC3 Regional Forum-34.webp'></img>
        </Link>
      </div>
  
      </div>

  
    </div> },
  
  { title: 'Australian Education Exhibition', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Sanskar School hosts Australian Education Exhibition</h1>
    </div>


    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Australian Education Exhibition/Australian Education Exhibition.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Australian Education Exhibition/Australian Education Exhibition-1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Australian Education Exhibition/Australian Education Exhibition-2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Australian Education Exhibition/Australian Education Exhibition-3.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Australian Education Exhibition/Australian Education Exhibition-4.webp'></img>
        </Link>
      </div>
 
      <div className='image-box'>
        <Link to="">
        <img src='../img/Australian Education Exhibition/Australian Education Exhibition-5.webp'></img>
        </Link>
      </div>

      <div className='image-box'>
        <Link to="">
        <img src='../img/Australian Education Exhibition/Australian Education Exhibition-6.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Australian Education Exhibition/Australian Education Exhibition-7.webp'></img>
        </Link>
      </div>
   
  
      </div>

  
    </div> },
  { title: 'Education Fair', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Education Fair held at Sanskar School</h1>
    </div>

    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Education Fair/Education Fair held at Sanskar School_0.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Education Fair/Education Fair held at Sanskar School_1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Education Fair/Education Fair held at Sanskar School_2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Education Fair/Education Fair held at Sanskar School_3.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Education Fair/Education Fair held at Sanskar School_4.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/Education Fair/Education Fair held at Sanskar School_5.webp'></img>
        </Link>
      </div>
 
  
      </div>

  
    </div> },

{ title: 'Global Education Fair', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Global Education Fair held at Sanskar School</h1>
    </div>


    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Global Education Fair/Global Education Fair held at Sanskar School.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Global Education Fair/Global Education Fair held at Sanskar School-1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Global Education Fair/Global Education Fair held at Sanskar School-2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Global Education Fair/Global Education Fair held at Sanskar School-3.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Global Education Fair/Global Education Fair held at Sanskar School-4.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Global Education Fair/Global Education Fair held at Sanskar School-5.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Global Education Fair/Global Education Fair held at Sanskar School-6.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
         <img src='../img/Global Education Fair/Global Education Fair held at Sanskar School-7.webp'></img>
        </Link>
      </div>

  
      </div>
  
    </div> },
  
{ title: 'Workshop and Interactive Session with U.S. University officials', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Workshop and Interactive session with U.S. University officials</h1>
    </div>

    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/U.S.University-officials/Workshop and Interactive session with U.S. University officials.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/U.S.University-officials/Workshop and Interactive session with U.S. University officials_1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/U.S.University-officials/Workshop and Interactive session with U.S. University officials_2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/U.S.University-officials/Workshop and Interactive session with U.S. University officials_3.webp'></img>  
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/U.S.University-officials/Workshop and Interactive session with U.S. University officials_4.webp'></img>  
        </Link>
      </div>
      </div>

    </div> },

{ title: 'Classes XI and XII Attend ICAE Global University Fair', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Students from classes XI and XII attend ICAE Global University Fair</h1>
    </div>

    
    <div className='career-counselling-row'>
      <div className='image-box'>
        <Link to="">
         <img src='../img/ICAE Global/CAE Global University Fair.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/ICAE Global/CAE Global University Fair_1.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/ICAE Global/CAE Global University Fair_2.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/ICAE Global/CAE Global University Fair_3.webp'></img>
        </Link>
      </div>
      <div className='image-box'>
        <Link to="">
        <img src='../img/ICAE Global/CAE Global University Fair_4.webp'></img>
        </Link>
      </div>
     
      <div className='image-box'>
        <Link to="">
        <img src='../img/ICAE Global/CAE Global University Fair_5.webp'></img>
        </Link>
      </div>
     
      <div className='image-box'>
        <Link to="">
        <img src='../img/ICAE Global/CAE Global University Fair_6.webp'></img>
        </Link>
      </div>
     
      <div className='image-box'>
        <Link to="">
        <img src='../img/ICAE Global/CAE Global University Fair_7.webp'></img>
        </Link>
      </div>
     
     
     
      </div>

  
    </div> },
  

  ];
  return (
    <div>
          <div className='ibdp-hero-sec'>
        <img src='newimg/Screenshot_24.webp'/>

      </div>
    <div className='career-counslling-sec'>
      <HorizontalTabs tabs={tabs} />
    </div>
    </div>
  )
}

export default Careercounselling;
